import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import useAuth from '../../hooks/useAuth';
import OnboardingGuard from '../onboarding/OnboardingGuard';
import { workflowAnalyticsSource } from '../../constants/workflowRoutes';

/**
 * Wraps premium routes. Redirects to landing with pilot message if user is not whitelisted.
 */
export default function PilotGate({ children }) {
  const { pilotWhitelisted, isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();
  const posthog = usePostHog();

  // Admin can access all premium routes (e.g. to connect broken broker accounts)
  if (isAdmin && isAdmin()) {
    return <OnboardingGuard>{children}</OnboardingGuard>;
  }

  if (!pilotWhitelisted) {
    const path = location.pathname + location.search;
    const source = workflowAnalyticsSource(location.pathname, location.search);
    posthog?.capture('pilot_gate_blocked', {
      attempted_route: path,
      is_authenticated: !!isAuthenticated,
    });
    return (
      <Navigate
        to="/"
        replace
        state={{ openEarlyAccessModal: true, earlyAccessSource: source }}
      />
    );
  }

  return <OnboardingGuard>{children}</OnboardingGuard>;
}
